import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'SignType/Combo', method: 'GET', token: token })
}
